import { Cancel } from '@material-ui/icons'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const StatusCross = () => (
  <ThemeProvider theme={theme}>
    <StatusCrossDiv />
  </ThemeProvider>
)

const StatusCrossDiv = styled(Cancel)`
  && {
    font-size: 16px;
    margin: 0 2px;
    color: ${props => props.theme.status.errorColor};
  }
`

export default StatusCross
